// @ts-nocheck this file isn't being used yet
import React, { useState, useEffect } from "react";

import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import { RoomOutlined } from "@mui/icons-material";

import { PageStandard } from "components/admin/PageStandard";
import { useUserContext } from "contexts/UserContext";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  InstallationDetail,
  InstallationDetailItem,
} from "components/forms/InstallationDetail";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes, ErrorResponse } from "contexts/ErrorContextData";
import { CREATE_INSTALATION } from "routers/routePaths";
import { fetchInstallations } from "api/automation";

const updateInstallations = async (
  token: string,
  buildingId: string,
  installations: InstallationDetailItem[]
): Promise<void> => {
  // TODO: Replace with actual API call
  // await buildingsAPI.updateInstallations(token, buildingId, installations);
};

export const InstalationsEdit = ({ history, match }) => {
  const { token, currentSpace } = useUserContext();
  const setError = useSetError();

  // Get buildingId from route params
  const buildingId = match?.params?.buildingId || "";

  const [installationsData, setInstallationsData] = useState<
    InstallationDetailItem[]
  >([]);

  useEffect(() => {
    const loadInstallations = async () => {
      try {
        const data = await fetchInstallations(token);
        console.log("Fetched installations data:", data); // Debug log
      } catch (error) {
        // @ts-expect-error
        setError(error.response?.data?.error as ErrorResponse);
      }
    };
    loadInstallations();
  }, [token, setError]);

  const handleSubmit = async () => {
    if (installationsData?.length && buildingId) {
      try {
        await updateInstallations(token, buildingId, installationsData);
        history.goBack();
      } catch (error) {
        // @ts-expect-error
        setError(error.response?.data?.error as ErrorResponse);
      }
    } else {
      setError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  const handleAdd = () => {
    history.push(CREATE_INSTALATION);
  };

  const handleInstallationUpdate = (
    updatedInstallation: InstallationDetailItem,
    position: number
  ) => {
    if (installationsData?.length) {
      const updatedInstallationsData = [...installationsData];
      updatedInstallationsData.splice(position, 1, updatedInstallation);
      setInstallationsData(updatedInstallationsData);
    }
  };

  const handleInstallationDelete = (position: number) => {
    const updatedInstallationsData = [...installationsData];
    updatedInstallationsData.splice(position, 1);
    setInstallationsData(updatedInstallationsData);
  };

  return (
    <PageStandard title="Instalações" onAdd={handleAdd}>
      <BlockStandard hideDivider>
        <Grid item container alignItems="center">
          <RoomOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentSpace?.schoolName}</Typography>
        </Grid>
      </BlockStandard>

      {!!installationsData?.length ? (
        installationsData.map((item, position) => {
          return (
            <InstallationDetail
              key={position}
              installationData={item}
              onChange={(updatedInstallation) => {
                handleInstallationUpdate(updatedInstallation, position);
              }}
              onDelete={() => handleInstallationDelete(position)}
            />
          );
        })
      ) : (
        <Grid item container justifyContent="center" alignItems="center">
          <CircularProgress size={150} sx={{ mt: 3 }} />
        </Grid>
      )}

      {!!installationsData?.length && (
        <Button variant="contained" onClick={handleSubmit}>
          Atualizar dados de instalações
        </Button>
      )}
    </PageStandard>
  );
};
